import React from 'react';
const contents = [{
  emoji: '📅',
  title: '+100 Kant-en-klare Yogalessen',
  description: 'Complete lessen voor elk niveau, direct te geven.'
}, {
  emoji: '🌿',
  title: 'Yoga bij Pijn en Klachten',
  description: 'Veilige protocollen voor rug, nek, heupen, knieën en meer.'
}, {
  emoji: '🪷',
  title: 'Yoga voor Senioren',
  description: 'Zachte, toegankelijke lessen voor oudere leerlingen.'
}, {
  emoji: '🌙',
  title: 'Yoga voor Stress, Angst en Beter Slapen',
  description: 'Kalmerende reeksen en ademhaling.'
}, {
  emoji: '📖',
  title: 'Yoga voor Beginners: De Eerste 30 Dagen',
  description: 'Een compleet startprogramma.'
}];
export function KitContentsSection() {
  return <section className="bg-brand-cream px-4 py-20 sm:px-6 md:py-28" data-id="element-98" data-mp="2sxtmmukywujm">
      <div className="mx-auto max-w-[1100px]" data-id="element-99" data-mp="2szxrpfulrzlh">
        <div className="mx-auto mb-12 max-w-2xl text-center md:mb-14" data-id="element-100" data-mp="2xxg0n68meeth">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-brand-terracotta" data-id="element-101" data-mp="32w0t2jhmru7d">Een bibliotheek voor je lespraktijk</p>
          <h2 className="text-3xl font-semibold tracking-[-0.02em] text-brand-text md:text-4xl" data-id="element-102" data-mp="10mnjv6yhhg0p">Wat zit er in Yoga Klaar?</h2>
        </div>
        <div className="grid auto-rows-fr grid-cols-1 gap-5 md:grid-cols-2 md:gap-6" data-id="element-103" data-mp="vom4ox46i0ui">
          {contents.map((item, index) => <article key={item.title} className={`flex h-full flex-col rounded-2xl border border-brand-creamDark bg-[#FBF9F5] p-7 text-center shadow-[0_8px_22px_rgba(46,42,38,0.04)] transition-shadow duration-300 hover:shadow-[0_14px_28px_rgba(46,42,38,0.07)] md:p-8 ${index === 4 ? 'md:col-span-2 md:mx-auto md:w-1/2' : ''}`} data-id="element-104" data-mp="mm4g4c11ww4c" data-mpi={index}>
              <div className="mb-5 text-3xl" data-id="element-105" data-mp="19l921101mt0y">{item.emoji}</div>
              <h3 className="font-serif text-xl font-semibold leading-tight text-brand-text" data-id="element-106" data-mp="15kyuvl0ilwki">{item.title}</h3>
              <p className="mt-3 text-sm leading-6 text-brand-gray" data-id="element-107" data-mp="2234wzl47p2j5">{item.description}</p>
            </article>)}
        </div>
      </div>
    </section>;
}